import { Component, EventEmitter, Input, Output, SimpleChange } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-password-strength',
    templateUrl: './password-strength.component.html',
    styleUrls: ['./password-strength.component.scss'],
    standalone: false
})
export class PasswordStrengthComponent {
  @Input() public passwordToCheck: string = "";
  @Output() passwordStrength = new EventEmitter<boolean>();
  bar0: string = "";
  bar1: string = "";
  bar2: string = "";
  bar3: string = "";
  msg = '';
  [key: string]: any;

  private colors = ['darkred', 'orangered', 'orange', 'yellowgreen'];

  constructor(
    private translateService: TranslateService
  ) {
  }

  private static checkStrength(p: string) {
    let force = 0;
    const regex = /[$-/:-?{-~!"^_@`\[\]]/g;

    const lowerLetters = /[a-z]+/.test(p);
    const upperLetters = /[A-Z]+/.test(p);
    const numbers = /[0-9]+/.test(p);
    const symbols = regex.test(p);

    const flags = [lowerLetters, upperLetters, numbers, symbols];

    let passedMatches = 0;
    for (const flag of flags) {
      passedMatches += flag === true ? 1 : 0;
    }

    force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
    force += passedMatches * 10;

    // short password
    force = (p.length <= 6) ? Math.min(force, 10) : force;

    // poor variety of characters
    force = (passedMatches === 1) ? Math.min(force, 10) : force;
    force = (passedMatches === 2) ? Math.min(force, 20) : force;
    force = (passedMatches === 3) ? Math.min(force, 30) : force;
    force = (passedMatches === 4) ? Math.min(force, 40) : force;

    return force;
  }

  ngOnChanges(changes: { [propName: string]: SimpleChange }): void {
    const password = changes['passwordToCheck'].currentValue;
    this.setBarColors(4, '#DDD');
    if (password) {
      const c = this.getColor(PasswordStrengthComponent.checkStrength(password));
      this.setBarColors(c.idx, c.col);

      const pwdStrength = PasswordStrengthComponent.checkStrength(password);
      pwdStrength === 40 ? this.passwordStrength.emit(true) : this.passwordStrength.emit(false);

      switch (c.idx) {
        case 1:
          this.msg = this.translateService.instant("Dialog.PasswordStrengthComponent.msg_poor");
          break;
        case 2:
          this.msg = this.translateService.instant("Dialog.PasswordStrengthComponent.msg_notGood");
          break;
        case 3:
          this.msg = this.translateService.instant("Dialog.PasswordStrengthComponent.msg_average");
          break;
        case 4:
          this.msg = this.translateService.instant("Dialog.PasswordStrengthComponent.msg_good");
          break;
      }
    } else {
      this.msg = '';
    }
  }


  private getColor(s: number) {
    let idx = 0;
    if (s <= 10) {
      idx = 0;
    } else if (s <= 20) {
      idx = 1;
    } else if (s <= 30) {
      idx = 2;
    } else if (s <= 40) {
      idx = 3;
    } else {
      idx = 4;
    }
    return {
      idx: idx + 1,
      col: this.colors[idx]
    };
  }

  private setBarColors(count: number, col: string) {
    for (let n = 0; n < count; n++) {
      this['bar' + n] = col;
    }
  }

}
